import React from 'react';
import {Alert} from 'reactstrap';
import PropTypes from "prop-types";

const ErrorAlert = ({errors = [], onClearError = f => f}) =>
    <div className="show-errors">
        {errors.map((message, i) => <Alert key={i} color="info" isOpen={true} toggle={() => onClearError(i)}>{message}</Alert>)}
    </div>;

ErrorAlert.propTypes = {
    errors: PropTypes.array.isRequired,
    onClearError: PropTypes.func.isRequired
};

export default ErrorAlert;